<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar :back="true" title="Accounts" :icon="require('@/assets/icon/accounts-active.svg')"
        @onBack="$navigationGoBack('/accounts')" @onTitleClick="$router.push({ path: '/accounts' })">
        <template #left-options>
          <accountSidebar switch_tab="attachments" :account="account"></accountSidebar>
        </template>

        <div class="options">
          <widgetProfile :title="account.name" subtitle="" file_name="" path="" @click="
            $router.push({ path: '/accounts' })
            " titleDirection="left"></widgetProfile>
        </div>
      </WidgetToolbar>
    </div>



    <div class="page-filters">
      <div class="page-left-panel">
        <h2>Attachments</h2>
      </div>

      <div class="options">
        <widgetButton :loading="false" @click="getStartData(), getProjectsData()" class="btn-transparent fit-content">
          <img src="@/assets/icon/reflesh-gray.svg" width="15" />
        </widgetButton>
        <div class="v-line-divider" style="height: 40px"></div>
        <widgetButton style="width: 120px" v-if="account.attachments.length > 0" @click="addNew()" :loading="false"
          class="btn-primary">
          Add attachment +
        </widgetButton>
      </div>

    </div>



    <div class="page-body">
      <div class="wrapper">
        <div class="section-widget">
          <div class="tab-body">
            <div class="attachments-wiget" :class="{ preview: isPreviewing }">
              <div class="attachment-header">
                <h3>Attachements</h3>
              </div>
              <div class="attachments-items" v-if="account.attachments.length > 0">
                <div class="attachment-item" v-for="(item, index) in account.attachments" :key="index">
                  <img v-if="fileExt(item.document) == 'docx'" src="@/assets/file-icon/word.svg" />
                  <img v-else-if="fileExt(item.document) == 'pdf'" @click.prevent="previewAttachment(item)" width="40"
                    src="@/assets/file-icon/pdf.svg" />
                  <img v-else-if="fileExt(item.document) == 'json'" src="@/assets/file-icon/json.svg" />
                  <img v-else-if="fileExt(item.document) == 'png' ||
                    fileExt(item.document) == 'jpg' ||
                    fileExt(item.document) == 'jpeg' ||
                    fileExt(item.document) == 'svg'
                  " src="@/assets/file-icon/image.svg" width="40" />
                  <img v-else width="28" src="@/assets/file-icon/file.svg" />
                  <div class="content" @click.prevent="previewAttachment(item)">
                    <h4>{{ item.title | validate }}</h4>
                    <p>{{ item.created_at | formatDate | validate }}</p>
                  </div>
                  <dropdown-menu class="menu">
                    <ul>
                      <li v-if="fileExt(item.document) == 'pdf'">
                        <a @click.prevent="previewAttachment(item)" href>Preview</a>
                      </li>
                      <li>
                        <a @click.prevent="downloadAttachment(item)" href>Download</a>
                      </li>
                      <li>
                        <a @click.prevent="updateAttachment(item)" href>Edit Attachment</a>
                      </li>
                      <li>
                        <a @click.prevent="deleteAttachment(item.id, i)" href>Delete Attachment</a>
                      </li>
                    </ul>
                  </dropdown-menu>
                </div>
              </div>

              <div v-else class="not-found-widget">
                <widgetNotFoundWidget title="Attachment not found"
                  content="Attachment are not available, click Add New button for new attachment"
                  btntext="Add attachment" @click="addNew()">
                  <img class="widget-img" src="@/assets/admin-icon/student-search-icon.svg" />
                </widgetNotFoundWidget>
              </div>
            </div>
            <!-- Preview pdf -->
            <div v-if="isPreviewing" class="pdf-previewer">
              <object :data="preview_pdf_url" type="application/pdf" width="100%" height="100%"></object>
            </div>
          </div>
        </div>

        <!-- Add - Update Modal -->
        <div class="overlay" v-if="show_form_add_update">
          <div class="form-widget-modal">
            <div class="moder-header">
              <h4 v-if="!attachment_form.id">Add Attachement and/or Link</h4>
              <h4 v-else>Edit Attachement and/or Link</h4>
            </div>
            <div class="modal-body">
              <div class="input-group">
                <label>Link/document title</label>
                <input type="text" v-model="attachment_form.title" class="input-form" />
              </div>

              <div class="input-group">
                <label>Link</label>
                <input type="text" v-model="attachment_form.link" class="input-form" />
              </div>

              <div class="input-group">
                <label>Document</label>
                <div class="upload-input">
                  <Uploader accept="application/pdf" @onFileSelected="(file) => {
                    attachment_form.file = file;
                  }
                  " :max_size="5" caption="Upload your document [max-size: 5MB] [pdf]" remove_caption="Remove file"
                    :value="{
                      url: $fullUrl('files/crm/'),
                      file_name: attachment_form.file_url,
                    }" />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <c-button :loading="adding_attachment_loading" @click="submitData" class="btn-save">Save</c-button>
              <button class="btn-cancel" @click="show_form_add_update = false">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import accountSidebar from "@/views/Accounts/components/account_sidebar.vue";

export default {
  components: {
    accountSidebar,
  },
  mounted() {
    let vm = this;
    vm.getStartData();
  },
  data: () => ({
    show_form_add_update: false,
    adding_attachment_loading: false,
    isPreviewing: false,
    attachment_form: {
      id: null,
      account_id: null,
      title: "",
      link: "",
      file: null,
      file_url: "",
    },
    account: {
      attachments: [],
    },
    preview_pdf_url: ""
  }),
  methods: {
    fileExt(file_name) {
      return file_name.split(".").pop();
    },
    previewAttachment(item) {
      let vm = this;
      if (vm.fileExt(item.document) == 'pdf') {
        const url = vm.$fullUrl("images/profiles/" + item.document);
        vm.preview_pdf_url = url;
        vm.isPreviewing = true;
      }
    },
    downloadAttachment(item) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_SINGLE_ATTACHMENT_DOWNLOAD_FILE", {
          id: item.id,
          name: item.document,
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", item.document); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error));
    },
    updateAttachment(item) {
      let vm = this;
      vm.show_form_add_update = true;
      vm.attachment_form.id = item.id;
      vm.attachment_form.account_id = item.account_id;
      vm.attachment_form.title = item.title;
      vm.attachment_form.link = item.link;
      vm.attachment_form.file = null;
      vm.attachment_form.file_url = item.document;
    },
    deleteAttachment(id) {
      let vm = this;
      vm.$store
        .dispatch("ACCOUNT_SINGLE_ATTACHMENT_DELETE", { id: id })
        .then((response) => {
          vm.getStartData();
        })
        .catch((error) => {
          console.error({ error });
        });
    },
    getStartData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("ACCOUNT_SINGLE_GET_ALL_DATA", {
          account_id: vm.$route.params.id,
        })
        .then((responce) => {
          vm.account = responce.data;
          vm.$store.dispatch("LOADER_CLOSE");
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    validURL(str) {
      var pattern = new RegExp(
        "^(https?:\\/\\/)?" +
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" +
        "((\\d{1,3}\\.){3}\\d{1,3}))" +
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" +
        "(\\?[;&a-z\\d%_.~+=-]*)?" +
        "(\\#[-a-z\\d_]*)?$",
        "i"
      );
      return !!pattern.test(str);
    },
    addNew() {
      let vm = this;
      vm.show_form_add_update = true;
      vm.attachment_form = {
        id: null,
        account_id: vm.$route.params.id,
        title: "",
        link: "",
        file: null,
        file_url: "",
      };
    },
    submitData() {
      let vm = this;
      const rules = {
        title: {
          run: (value) => {
            if (value.length > 0) {
              return false;
            }
            return "Title can not be empty";
          },
        },
        link: {
          run: (value) => {
            if (value) {
              if (!vm.validURL(value)) {
                return "Invalid link";
              }
            }
            return false;
          },
        },
        file: {
          run: (value) => {
            if (!vm.attachment_form.file_url) {
              if (value) {
                return false;
              }
              return "Please select attachment";
            }
          },
        },
      };
      if (vm.$isFieldsValidated(vm.attachment_form, rules)) {
        vm.adding_attachment_loading = true;
        let form_data = new FormData();
        form_data.append("id", vm.attachment_form.id);
        form_data.append("account_id", vm.attachment_form.account_id);
        form_data.append("title", vm.attachment_form.title);
        form_data.append("link", vm.attachment_form.link);
        if (vm.attachment_form.file) {
          form_data.append(
            "file",
            vm.attachment_form.file,
            vm.attachment_form.file.name
          );
        }
        if (!vm.attachment_form.id) {
          vm.$store
            .dispatch("ACCOUNT_SINGLE_ATTACHMENT_ADD_NEW", form_data)
            .then((response) => {
              vm.adding_attachment_loading = false;
              vm.show_form_add_update = false;
              vm.getStartData();
            })
            .catch((error) => {
              console.error({ error });
              vm.adding_attachment_loading = false;
            });
        } else {
          vm.$store
            .dispatch("ACCOUNT_SINGLE_ATTACHMENT_UPDATE", form_data)
            .then((response) => {
              vm.adding_attachment_loading = false;
              vm.show_form_add_update = false;
              vm.getStartData();
            })
            .catch((error) => {
              console.error({ error });
              vm.adding_attachment_loading = false;
            });
        }
      }
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    .options {
      display: flex;
      align-items: center;

      .search-account {
        width: 250px;
      }

      .btn-add {
        margin-left: 20px;
        width: 130px;
      }
    }
  }

  .page-filters {
    width: 100%;
    height: 40px;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 5px;
    padding: 0 10px;

    .page-left-panel {
      display: flex;
      align-items: center;
    }

    .options {
      display: flex;
      align-items: center;
    }
  }


  .page-body {
    height: calc(100% - 83px);
    display: flex;

    .wrapper {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;

      .section-widget {
        height: 100%;
        display: flex;
        width: 100%;
        flex-direction: column;

        .tab-body {
          padding: 0px;
          display: flex;
          width: 100%;
          height: 100%;

          .attachments-wiget {
            background: #fff;
            border-radius: 5px;
            height: 100%;
            width: 100%;
            display: flex;
            flex-direction: column;
            transition: all 0.5s ease-in-out;

            &.preview {
              width: 260px !important;
              margin-right: 5px;
              transition: all 0.5s ease-in-out;
            }

            .attachment-header {
              display: flex;
              justify-content: space-between;
              padding: 10px 10px;

              h3 {
                font-size: 14px;
                margin: 0px;
              }

              .btn-add {
                color: #1ba5a4;
              }
            }

            .attachments-items {
              display: block;
              padding: 0 10px;
              width: 100%;
              height: calc(100vh - 50px);
              overflow-y: auto;

              .attachment-item {
                display: flex;
                align-items: center;
                background: #f7f7f7;
                padding: 10px 2px;
                margin-bottom: 15px;
                width: 100%;
                border-radius: 5px;
                position: relative;
                cursor: pointer;

                &:hover {
                  background: #ebebeb;
                }

                .menu {
                  position: absolute;
                  top: 18px;
                  right: 10px;
                }

                img {
                  margin-right: 10px;
                  width: 40px;
                  height: 30px;
                }

                .content {

                  h4,
                  p {
                    margin: 0px;
                  }

                  h4 {
                    font-size: 14px;
                  }

                  p {
                    color: #6e6e6e;
                  }
                }
              }
            }

            .not-found-widget {
              .widget-img {
                width: 130px;
              }
            }
          }

          .pdf-previewer {
            width: 100%;
            height: 100%;
            padding: 10px;
            background-color: #fff;
            border-radius: 5px;

            object {
              width: 100%;
              height: 100%;
            }

          }
        }
      }

      .form-widget-modal {
        width: 400px;
      }
    }
  }
}
</style>
